import { Modal, Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import { FiUpload } from "react-icons/fi";
import { CSVLink } from "react-csv";
import { useRef, useState, useContext, useEffect } from "react";
import CourseService from "../../../../services/CourseService";
import AlertService from "../../../../services/AlertService";
import AuthContext from "../../../../auth/AuthContext";

function UploadTemplateModal({ show, handleClose, courseId, onSuccess }) {
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const authContext = useContext(AuthContext);
  const submitControllerRef = useRef(null);

  const headers = [
    { label: "EmailId", key: "emailId" },
    { label: "VMName", key: "vmName" },
    { label: "UserName", key: "userName" },
    { label: "Password", key: "password" },
    { label: "Status", key: "status" },
    { label: "Reason", key: "reason" },
  ];

  const handleFileSelect = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0]?.name || "");
  };


const handleSubmit = async (e) => {
  e.preventDefault();
  if (!file) {
    AlertService.error("Please select a file");
    return;
  }

  if (submitControllerRef.current) {
    submitControllerRef.current.abort();
  }
  const controller = new AbortController();
  submitControllerRef.current = controller;

  setLoading(true);

  const formData = new FormData();
  formData.append("file", file);
  formData.append("filename", file.name);

  try {
    const data = await CourseService.ImportUserGVM(
      courseId,
      formData,
      authContext,
      controller.signal
    );

    if (controller.signal.aborted) return;

    if (data?.isSuccess) {
      AlertService.success("User VMs are imported successfully!");
      setResults(data.data || []);
      onSuccess?.();
    } else {
      AlertService.error(data.errorMessage);
    }
  } catch (err) {
    if (err.name === "AbortError") return;
    console.error("Unhandled error:", err);
  } finally {
    if (!controller.signal.aborted) setLoading(false);
  }
};

// Unmount cleanup
useEffect(() => {
  return () => {
    submitControllerRef.current?.abort();
  };
}, []);

  useEffect(() => {
    if (!show) {
      setFile(null);
      setFileName("");
      setResults([]);
      setLoading(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      centered
      size="xl"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="w-100 text-center">Upload Template</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} noValidate>
          <Form.Group as={Row} className="mb-3 align-items-center">
            <Form.Label
              column
              md={2}
              className="d-flex align-items-center"
              style={{ minHeight: "48px" }}
            >
              Select Excel File
            </Form.Label>
            <Col md={10}>
              <InputGroup>
                <Form.Control
                  type="text"
                  placeholder="Upload file"
                  readOnly
                  value={fileName}
                  className="py-3 custom-input-color"
                  style={{ background: "#fff" }}
                />
                <Button
                  variant="primary"
                  className="px-3 rounded"
                  onClick={() => fileInputRef.current.click()}
                  type="button"
                >
                  <FiUpload className="fs-4" />
                </Button>
                <Form.Control
                  type="file"
                  ref={fileInputRef}
                  className="d-none"
                  accept=".xls,.xlsx,.csv"
                  onChange={handleFileSelect}
                />
              </InputGroup>
            </Col>
          </Form.Group>

          <Row className="mb-3 mt-4">
            <Col className="d-flex justify-content-end align-items-center gap-4">
              <Button
                variant="outline-secondary"
                className="px-4 py-2 px-md-5"
                onClick={handleClose}
                disabled={loading}
              >
                {results.length > 0 ? "Close" : "Cancel"}
              </Button>

              {results.length === 0 ? (
                <Button
                  variant="primary"
                  className="px-4 px-md-5 py-2"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Processing..." : "Submit"}
                </Button>
              ) : (
                <CSVLink
                  data={results}
                  filename={"VM-Upload-Results.csv"}
                  className="btn btn-success px-4 py-2"
                  headers={headers}
                >
                  Download Results
                </CSVLink>
              )}
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default UploadTemplateModal;
